import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MouseIntentOptions } from './mouse-intent.interface';

const MOUSE_EVENT = {
    OVER: 'mouseover',
    OUT: 'mouseout',
    INTENT: 'mouseintent',
};

@Injectable()
export class MouseIntentService implements OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {}

    /* istanbul ignore next */
    ngOnDestroy() {
        // Ignore the if just for coverage, there's no need to test unsubscribe
        this.destroy$.next();
        this.destroy$.complete();
    }

    bind(options: MouseIntentOptions) {
        const elem = options.element.nativeElement;
        const duration = options.duration;
        let timer: NodeJS.Timeout = null;

        fromEvent(elem, MOUSE_EVENT.OVER)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                /* istanbul ignore if */
                if (timer !== null) {
                    return;
                }

                timer = setTimeout(() => {
                    const event = new CustomEvent(MOUSE_EVENT.INTENT);
                    this.document.dispatchEvent(event);
                    timer = null;
                }, duration);
            });

        fromEvent(elem, MOUSE_EVENT.OUT)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                options.mouseOutCallback();
                clearTimeout(timer);
                timer = null;
            });

        fromEvent(this.document, MOUSE_EVENT.INTENT)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                options.mouseIntentCallback();
            });
    }
}
